import React, { useState, useEffect } from "react";
import moment from "moment";
import makeStyles from "@mui/styles/makeStyles";
import { TextField, Button, Box, FormHelperText } from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  inputRoot: {
    width: 160,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      width: 180
    }
  },
  nowButton: {
    marginTop: 18
  }
}));

const DateTimeInput = ({ value, onChange, disabled, error, helperText }) => {
  const classes = useStyles();
  const [dateStr, setDateStr] = useState("");
  const [timeStr, setTimeStr] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const m = moment(value);
    setDateStr(m.format("MM/DD/YYYY"));
    setTimeStr(m.format("h:mm A"));
    value === undefined && onChange(m.toDate());
  }, [value]);

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start">
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems="flex-start"
      >
        <TextField
          value={dateStr}
          onChange={ev => {
            setDateStr(ev.target.value);
          }}
          onBlur={ev => {
            const m = moment(ev.target.value, "MM/DD/YYYY");
            if (m.isValid()) {
              const dateStr1 = m.format("MM/DD/YYYY");
              setDateStr(dateStr1);
              if (onChange) {
                const newDate = moment(
                  dateStr1 + " " + timeStr,
                  "MM/DD/YYYY h:mm A"
                ).toDate();
                onChange(newDate);
              }
            } else {
              const m0 = moment(value);
              const dateStr1 = m0.format("MM/DD/YYYY");
              setDateStr(dateStr1);
            }
          }}
          variant="filled"
          error={error}
          InputProps={{
            classes: {
              root: classes.inputRoot
            },
            placeholder: "MM/DD/YYYY"
          }}
          hiddenLabel
          disabled={disabled}
        />
        <TextField
          value={timeStr}
          onChange={ev => {
            setTimeStr(ev.target.value);
          }}
          onBlur={ev => {
            const m = moment(ev.target.value, "h:mm A");
            if (m.isValid()) {
              const timeStr1 = m.format("h:mm A");
              setTimeStr(timeStr1);
              if (onChange) {
                const newDate = moment(
                  dateStr + " " + timeStr1,
                  "MM/DD/YYYY h:mm A"
                ).toDate();
                onChange(newDate);
              }
            } else {
              const m0 = moment(value);
              const timeStr1 = m0.format("h:mm A");
              setTimeStr(timeStr1);
            }
          }}
          variant="filled"
          error={error}
          InputProps={{
            classes: {
              root: classes.inputRoot
            },
            placeholder: "h:mm A"
          }}
          hiddenLabel
          disabled={disabled}
        />
        <Button
          className={classes.nowButton}
          color="primary"
          onClick={() => {
            const m = moment();
            setDateStr(m.format("MM/DD/YYYY"));
            setTimeStr(m.format("h:mm A"));
          }}
          disabled={disabled}
        >
          {t("nowBtn")}
        </Button>
      </Box>
      {error && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </Box>
  );
};

export default DateTimeInput;
